<template>
    <div class="app-download-dialog" data-skeleton-remove v-if="alwaysShow">
        <div @click="close" class="app-download__close">
            <img src="../../images/common/appdownload-close.png" />
        </div>
        <div class="app-download__logo">
            <img src="../../images/common/appdownload-logo.png" />
        </div>
        <div class="app-download__text" v-if="isNewUser">
            您已获得价值299元的吃喝玩乐
            <br />权益卡，下载 <span class="app-download__bold">APP</span>即可享
        </div>
        <div class="app-download__text" v-else>
            打开骑士特权APP，购物更轻松
            <br />专享加油 <span class="app-download__bold">{{ text.oilDiscountNum }}</span
            >折起/视频会员 <span class="app-download__bold">{{ text.videoDiscountNum }}</span
            >折起
        </div>
        <div @click="gotoDownload()" class="app-download__btn">立即打开</div>
    </div>
</template>
<script>
import text from 'root/common/const/text';
import storage from 'root/common/util/storage';
import env from 'root/common/util/env';

// import transferDom from 'root/blackcard/directives/transfer-dom';
export default {
    data() {
        const isTouTiaoMini = navigator.userAgent.match(/toutiaomicroapp/i);
        const isWechatMini = navigator.userAgent.match(/miniprogram/i) || window.__wxjs_environment === 'miniprogram';
        return {
            show: false,
            isApp: window.ZZCFL.Utils.UA.browser.name === 'black',
            alipayHidden: window.isAliPayClient,
            isTouTiaoMini,
            isWechatMini,
            isZfbMini: false,
            text,
            business: storage.get('shareBusiness'),
            notCurrentDay: false,
        };
    },
    props: {
        appDownload: {},
        showBarParams: {
            default: true,
        },
        isNewUser: {
            default: false,
        },
    },
    mounted() {
        const self = this;
        if (window.my) {
            // 判断是否运行在小程序环境里
            window.my.getEnv(function(res) {
                self.isZfbMini = res.miniprogram;
                self.checkShow();
            });
        } else {
            self.checkShow();
        }
    },
    computed: {
        alwaysShow() {
            return (
                !env.isBaiduBoxJisu &&
                !window.__is_blackApp &&
                !this.isZfbMini &&
                this.notCurrentDay &&
                !env.isWechatMini
            );
        },
    },
    methods: {
        checkShow() {
            this.notCurrentDay = localStorage.getItem('appdownloadcurrent') != new Date().getDate();
            if (!this.alwaysShow) {
                this.close();
            } else {
                this.$emit('update:appDownload', true);
            }
            if (this.isNewUser) {
                window.bigTj &&
                    window.bigTj.track('show', {
                        obj_id: 'download',
                        obj_type: 'visitor_payfinish_page',
                        item_name: this.business,
                        location: this.business,
                        item_id: '',
                        item_sort: 1,
                        location_id: '',
                        location_sort: 1,
                        sa_card_id: '',
                        page_source_type: '',
                    });
            }

            setTimeout(() => {
                const isAppUser = this.isAppUser();
                const curHref = window.location.href;

                // 头条小程序跟微信下不显示
                if (isAppUser || this.isTouTiaoMini || this.isWechatMini) {
                    window.sessionStorage.setItem('SET_APP_DOWNLOAD', '0');
                }
                if (
                    !isAppUser &&
                    window.sessionStorage.getItem('SET_APP_DOWNLOAD') !== '0' &&
                    !this.isApp &&
                    this.showBarParams &&
                    !this.alipayHidden &&
                    !curHref.includes('withBar=0')
                ) {
                    this.$emit('update:appDownload', true);
                }
            }, 1500);
        },
        close() {
            this.$emit('close');
            this.$emit('update:appDownload', false);
            // this.$store.commit('SET_APP_DOWNLOAD', '0');
            this.notCurrentDay = false;
            let currentDay = new Date().getDate();
            localStorage.setItem('appdownloadcurrent', currentDay);
            window.sessionStorage.setItem('SET_APP_DOWNLOAD', '0');
        },
        gotoDownload() {
            this.isNewUser &&
                window.bigTj &&
                window.bigTj.track('click', {
                    obj_id: 'download',
                    obj_type: 'visitor_payfinish_page',
                    item_name: this.business,
                    location: this.business,
                    item_id: '',
                    item_sort: 1,
                    location_id: '',
                    location_sort: 1,
                    sa_card_id: '',
                    page_source_type: '',
                });
            if (window.__is_weixin) {
                let redirect = location.href;
                window.location.href = `${location.origin}/new/transit/download/?redirect=${redirect}`;
            } else {
                window.location.href = 'https://a.app.qq.com/o/simple.jsp?pkgname=com.black.unique';
            }
        },
        isHideAppDownload() {
            return !this.alwaysShow;
            // return window.sessionStorage.getItem('SET_APP_DOWNLOAD') == '0';
        },
        isAppUser() {
            return false;
            // const paramsStr = window.localStorage.getItem('isAppUserParams');
            // let paramsObj;
            // if (!paramsStr) {
            //     return false;
            // }
            // try {
            //     paramsObj = JSON.parse(paramsStr);
            // } catch (error) {
            //     return false;
            // }
            // return paramsObj.isAppUser;
        },
    },
};
</script>
<style lang="scss" scoped>
.app-download-dialog {
    height: 1rem;
    width: 100%;
    max-width: 750px;
    background-color: #fff;
    background-image: url(../../images/common/appdownload-bg.png);
    background-size: 100% 100%;
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    margin: auto;
    z-index: 2030;
    display: flex;
    justify-content: center;
    align-items: center;
    border: none;
    .app-download__close {
        position: relative;

        width: 0.26rem;
        height: 0.26rem;
        & > img {
            font-size: 0;
            width: 100%;
            height: 100%;
        }
        &::before {
            content: '';
            width: 0.8rem;
            height: 0.8rem;
            position: absolute;
            display: block;
            top: -0.26rem;
            left: -0.2rem;
        }
    }
    .app-download__logo {
        margin-left: 0.28rem;
        width: 0.66rem;
        height: 0.66rem;
        & > img {
            font-size: 0;
            width: 100%;
            height: 100%;
        }
    }
    .app-download__text {
        font-size: 0.24rem;
        color: #333;
        margin: 0.2rem;
        white-space: nowrap;
        .app-download__bold {
            font-weight: 700;
            font-size: 0.26rem;
        }
    }
    .app-download__btn {
        position: relative;
        display: inline-block;
        width: 1.8rem;
        height: 0.6rem;
        text-align: center;
        line-height: 0.6rem;
        background-image: url(../../images/common/appdownload-btn.png);
        background-size: 100% 100%;
        font-size: 0.26rem;
        color: #fff2c9;
        &::before {
            content: '';
            width: 116.1%;
            height: 0.8rem;
            position: absolute;
            display: block;
            top: -0.09rem;
            left: -0.1rem;
        }
    }
}
</style>
